var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function generateResultImage(imgUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const { imgElement: resultImage, width, height } = yield buildImage(imgUrl);
        const canvasMaxSize = 1490;
        const ratio = Math.max(width, height) / canvasMaxSize;
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.id = 'resultCanvas';
        canvas.width = width / ratio;
        canvas.height = height / ratio;
        const ctx = canvas.getContext('2d');
        document.body.appendChild(canvas);
        ctx.drawImage(resultImage, 0, 0, width / ratio, height / ratio);
        const imgdata = canvas.toDataURL('image/jpeg');
        return imgdata;
    });
}
function buildImage(src) {
    return new Promise(function (resolve, reject) {
        let canvasImage = new Image();
        canvasImage.crossOrigin = '';
        canvasImage.onload = () => {
            resolve({
                width: canvasImage.width,
                height: canvasImage.height,
                imgElement: canvasImage
            });
        };
        canvasImage.onerror = (e) => {
            reject(e);
        };
        canvasImage.src = src;
    });
}
